import { configure, defineRule } from 'vee-validate'
import {
  length,
  numeric,
  required,
  email,
  min,
  max,
  max_value as maxValue,
  min_value as minValue
} from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'
import { messages as validationMessages } from '@/plugins/i18n'

// eslint prefer-regex-literals
const regExp = {
  regularField: /^[^<>`{}=]+$/,
  buildingOrFlatField: /^(?=.*\d)[a-zA-Z\d\-/]{0,180}$/i,
  phone: /^[0-9]{9,21}$/,
  street: /^[A-ZĄĆĘŚŁŃÓŻŹ0-9\\s-–.]*[A-ZĄĆĘŚŁŃÓŻŹ][A-ZĄĆĘŚŁŃÓŻŹ0-9\\s-–.]*$/i
}

configure({
  generateMessage: localize({
    pl: {
      messages: {
        ...validationMessages.pl.validation
      }
    }
  })
})
setLocale('pl')

defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('max_value', maxValue)
defineRule('min_value', minValue)
defineRule('min_fundraising', minValue)
defineRule('min_donate', minValue)
defineRule('length', length)
defineRule('numeric', numeric)

defineRule('excludeSpecial', (value) => {
  if (!required(value)) return true

  const reg = /^[^<>`{}=]*$/i
  return value && reg.test(value)
})

defineRule('phoneNumber', (value) => {
  if (!required(value)) return true

  const trimmed = value?.replace(/\s+/g, '')
  return trimmed?.match(regExp.phone)
})

defineRule('regularField', (value) => value?.match(regExp.regularField))

defineRule('city', (value) => value && regExp.regularField.test(value) && value.length <= 180)

defineRule('postalCode', (value) => value.length === 6)

defineRule('street', (value) => value?.match(regExp.street))

defineRule('buildingOrFlatField', (value) => {
  if (!value) return true
  return value?.match(regExp.buildingOrFlatField)
})
